/**
 * Initializes custom file upload functionality for Gravity Forms.
 * Finds file inputs with a specific class and attaches event listeners
 * to handle displaying the selected file name and allowing file removal.
 */
export function initCustomFileUpload() {
    const fileInputs = document.querySelectorAll('.ginput_container_fileupload .large');
    if (!fileInputs.length) {
        return;
    }
    fileInputs.forEach((fileInput) => {
        const group = fileInput.closest('.group');
        if (!group)
            return;
        const fileNameDisplay = group.querySelector('.file-name');
        const fileNameText = group.querySelector('.file-name-text');
        const removeButton = group.querySelector('.remove-file');
        applyEventListenerOnChange(fileInput, fileNameText, fileNameDisplay);
        applyEventListenerOnClick(removeButton, fileInput, fileNameText, fileNameDisplay);
    });
}
/**
 * Attaches a 'change' event listener to a file input.
 * Updates the file name display when a file is selected,
 * and toggles visibility based on whether a file is present.
 *
 * @param {HTMLInputElement} target - The file input element.
 * @param {HTMLElement} fileNameText - The span element displaying the file name.
 * @param {HTMLElement} fileNameDisplay - The container for the file name display.
 */
function applyEventListenerOnChange(target, fileNameText, fileNameDisplay) {
    target.addEventListener('change', function () {
        if (this.files.length > 0) {
            fileNameText.textContent = this.files[0].name;
            fileNameDisplay.classList.add('faux-list-item--show');
        }
        else {
            fileNameText.textContent = '';
            fileNameDisplay.classList.remove('faux-list-item--show');
        }
    });
}
/**
 * Attaches a 'click' event listener to a remove button.
 * Clears the file input value and hides the file name display when clicked.
 *
 * @param {HTMLElement} target - The button element that triggers file removal.
 * @param {HTMLInputElement} fileInput - The associated file input element.
 * @param {HTMLElement} fileNameText - The span element displaying the file name.
 * @param {HTMLElement} fileNameDisplay - The container for the file name display.
 */
function applyEventListenerOnClick(target, fileInput, fileNameText, fileNameDisplay) {
    target.addEventListener('click', function (e) {
        e.preventDefault();
        fileInput.value = '';
        fileNameText.textContent = '';
        fileNameDisplay.classList.remove('faux-list-item--show');
    });
}
